<template>
  <div class="page-join">
    <header>
      <div class="wrap">
        <div class="logo-wrap">
          <img :src="require(`../../../assets/index/logo.png`)" alt="">
        </div>
        <ul class="nav">
          <li :class="currentNav == 0?'cur':''" @click="toIndex">首页
            <div class="line"></div>
          </li>
          <li :class="currentNav == 1?'cur':''">小布壳
            <div class="line"></div>
            <div class="child-box">
              <div class="item one" @click="toQ1">小布壳Q1</div>
              <div class="item two" @click="toBrand">小布壳品牌</div>
            </div>
          </li>
          <li :class="currentNav == 2?'cur':''" @click="toAbout">关于偶家
            <div class="line"></div>
          </li>
          <li :class="currentNav == 3?'cur':''">加入偶家
            <div class="line"></div>
          </li>
        </ul>
      </div>
    </header>

    <div class="main-wrap">
      <div class="banner">
        <img :src="require(`../../../assets/join/banner.jpg`)" alt="">
      </div>
      <div class="main">
        <ul class="join">
          <li class="one">
            <div class="title">APP架构师</div>
            <div class="title2">岗位职责：</div>
            <div class="content">
              1. 负责完成移动客户端Android/IOS应用程序相关项目的需求分析、用跨平台开发框架（React Native）搭建项目，及计及模块和任务划分；<br>
              2. 承担核心模块的设计、开发工作，负责技术难点攻克；<br>
              3. 对移动APP应用质量负责，按时按质交付版本。
            </div>
            <div class="title2">岗位要求：</div>
            <div class="content">
              1. 负责完成移动客户端Android/IOS应用程序相关项目的需求分析、用跨平台开发框架（React Native）搭建项目，及计及模块和任务划分；<br>
              2. 承担核心模块的设计、开发工作，负责技术难点攻克；<br>
              3. 对移动APP应用质量负责，按时按质交付版本
            </div>
          </li>
          <li class="content">
            <div>
              请发送简历至 : 
              <a href="mailto:hr@xiaobuke.com">hr@xiaobuke.com</a>
            </div>
            <div>邮件标题格式为 : 应聘 + 职位名称</div>
          </li>
        </ul>
        <div class="bot">
          <img :src="require(`../../../assets/join/bg.jpg`)" alt="">
        </div>
        <img class="deco-join" :src="require(`../../../assets/join/icon_join.png`)" alt="">
      </div>
    </div>
    
    <footer>
      <div class="fot-nav clean">
        <div class="main-one">
          <div class="top-l-img">
            <img :src="require(`../../../assets/footer/l-1.png`)" alt="">
            <img :src="require(`../../../assets/footer/l-2.png`)" alt="">
          </div>
          <div class="c-word">
            深圳市南山区招商街道沿山社区南海大道1077号北科创业大厦701
            <img
              :src="require(`../../../assets/footer/icon_address.png`)"
              alt=""
            >
          </div>
          <div class="c-word">
            联系电话:0755-82842710
            <img :src="require(`../../../assets/footer/icon_address.png`)" alt="">
          </div>
        </div>
        <div class="main-two">
          <div class="tip">偶家科技（小布壳）微信微博</div>
          <div class="contact-wrap">
            <div class="contact-item one">
              <img :src="require(`../../../assets/footer/xl.png`)" alt="">
              <div class="sub">
                <img :src="require(`../../../assets/footer/wb_qrcode.jpg`)" alt="">
              </div>
            </div>
            <div class="contact-item two">
              <img :src="require(`../../../assets/footer/wx.png`)" alt="">
              <div class="sub">
                <img :src="require(`../../../assets/footer/wx_qrcode.jpg`)" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="main-three">
          <ul>
            <li>
              <div class="title">推荐产品</div>
              <div class="item" @click="toQ1">小布壳Q1</div>
              <div class="item" @click="topicturebooks">精彩绘本</div>
            </li>
            <li>
              <div class="title">关于我们</div>
              <div class="item" @click="toAbout">关于偶家</div>
              <div class="item">加入我们</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="fot-copy">Copyright © 2020 xiaobuke. All Rights Reserved
        <br>粤ICP备16087044号-2
      </div>
    </footer>
    <el-backtop :bottom="100">
      <img :src="require(`../../../assets/index/go_top.jpg`)" alt="">
    </el-backtop>
  </div>
</template>

<script>
import axios from "axios"

export default {
  name: "join",
  data() {
    return {
      currentNav: 3,
      isFixed: false,
      offsetTop: 0,
      currentxbk: 0
    };
  },
  methods: {
    toIndex() {
      this.$router.push({ path: "/" })
    },
    toQ1() {
      this.$router.push({ path: "Q1" })
    },
    toBrand() {
      this.$router.push({ path: "brand" })
    },
    initHeight() {
      // 设置或获取位于对象最顶端和窗口中可见内容的最顶端之间的距离 (被卷曲的高度)
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //如果被卷曲的高度大于吸顶元素到顶端位置 的距离
      this.isFixed = scrollTop > this.offsetTop ? true : false
    },
    topicturebooks() {
      this.$router.push({ path: "picturebooks" })
    },
    toOJApp() {
      this.$router.push({ path: "OJApp" })
    },
    toAbout() {
      this.$router.push({ path: "about" })
    },
    toBootstrap(){
      this.$router.push({ path: "bootstrap" })
    }
  },
  activated() {},
  mounted() {
    window.addEventListener("scroll", this.initHeight)
    this.$nextTick(() => {
      //获取对象相对于版面或由 offsetTop 属性指定的父坐标的计算顶端位置
      this.offsetTop = document.querySelector("#boxFixed").offsetTop
    });
  },
  computed: {},
  watch: {}
};
</script>

<style lang="scss">
.page-join {
  width: 100%;
  header {
    width: 100%;
    height: 100px;
    background: #000;
    .wrap {
      max-width: 1200px;
      height: 100%;
      margin: auto;
      .logo-wrap {
        float: left;
        cursor: pointer;
        img {
          vertical-align: middle;
          max-width: 100%;
          max-height: 100%;
        }
      }
      ul {
        float: right;
        li {
          float: left;
          margin: 0 35px;
          line-height: 100px;
          position: relative;
          font-size: 14px;
          color: #fff;
          cursor: pointer;
          .line {
            width: 100%;
            height: 1px;
            background: #000;
            position: absolute;
            bottom: 20px;
            left: 0;
          }
          .child-box {
            display: none;
          }
        }
        li:last-child {
          margin-right: 0;
        }
        li.cur {
          color: #f95c57;
          .line {
            background: #f95c57;
            bottom: 30px;
            -webkit-transition: all 300ms ease 0s;
            transition: all 300ms ease 0s;
          }
        }
        li:hover {
          color: #f95c57;
          .child-box {
            display: block;
            width: 100px;
            background: #000;
            position: absolute;
            left: -24px;
            bottom: -72px;
            padding-bottom: 4px;
            z-index: 199;
            .item {
              width: 100%;
              height: 36px;
              color: #fff;
              text-align: center;
              line-height: 36px;
              font-size: 13px;
            }
            .item.one:hover {
              color: #f95c57;
            }
            .item.two:hover {
              color: #f95c57;
            }
          }
        }
        li:hover .line {
          background: #f95c57;
          bottom: 30px;
          -webkit-transition: all 300ms ease 0s;
          transition: all 300ms ease 0s;
        }
      }
    }
  }
  .main-wrap{
    .banner{
      background: #eee;
      font-size: 0;
    }
    .main{
      max-width: 1200px;
      margin: auto;
      position: relative;
      .join {
        background: #eefdff;
        margin: 140px 0 50px;
        padding: 0 50px;
        li{
          font-size: 14px;
          color: #333;

          padding: 50px 0;
          list-style-type: none;
          .title{
            font-size: 24px;
          }
          .title2{
            font-size: 18px;
            margin: 20px 0 15px;
          }
          .content{
            font-size: 14px;
            color: #9b9b9b;
            line-height: 2;
          }
        }
        li.one{
          border-bottom: 1px dashed #ccc;
        }
        li.content{
          line-height: 1.8;
          a{
            color: #333;
          }
          a:hover{
            color: red;
          }
        }
      }
      .bot{
        font-size: 0;
      }
      .deco-join{
        width: 179px;
        height: 178px;
        position: absolute;
        right: -40px;
        top: -120px;
      }
    }
  }
  footer {
    width: 100%;
    height: 529px;
    background: #000;
    .fot-nav {
      max-width: 1200px;
      margin: auto;
      border-bottom: 1px solid #333;
      .main-one {
        float: left;
        padding: 50px 0;
        .top-l-img {
          font-size: 14px;
          img {
            margin-right: 19px;
          }
        }
        .c-word {
          padding-left: 30px;
          font-size: 15px;
          color: #fff;
          line-height: 24px;
          margin-top: 40px;
          position: relative;
          img {
            height: 24px;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
      }
      .main-two {
        float: right;
        padding: 80px 0;
        .tip {
          font-size: 15px;
          display: block;
          color: #fff;
          margin-bottom: 20px;
        }
        .contact-wrap {
          .contact-item {
            margin-left: 45px;
            padding-bottom: 20px;
            float: right;
            position: relative;
            font-size: 0;
            .sub {
              width: 180px;
              height: 180px;
              padding: 5px;
              background: #fff;
              position: absolute;
              left: 50%;
              margin-left: -95px;
              top: 100%;
              display: none;
              z-index: 99;
              img {
                vertical-align: middle;
                max-width: 100%;
                max-height: 100%;
              }
            }
          }
          .contact-item.one:hover {
            .sub {
              display: block;
            }
          }
          .contact-item.two:hover {
            .sub {
              display: block;
            }
          }
        }
      }
      .main-three {
        float: right;
        ul {
          padding: 80px 0;
          li {
            margin-right: 110px;
            float: left;
            .title {
              font-size: 15px;
              display: block;
              color: #fff;
              margin-bottom: 20px;
            }
            .item {
              font-size: 14px;
              display: block;
              color: #b0b0b0;
              margin-bottom: 10px;
              line-height: 1.5;
            }
            .item:hover {
              color: #fff;
              cursor: pointer;
            }
          }
        }
      }
    }
    .clean:after {
      clear: both;
      content: "";
      display: block;
    }
    .fot-copy {
      padding: 50px 0 110px;
      line-height: 40px;
      font-size: 16px;
      color: #545454;
      text-align: center;
    }
  }
  .el-backtop {
    position: fixed;
    width: 70px;
    height: 70px;
    border-radius: 0;
    -webkit-box-shadow: 0 0 9px #999;
    box-shadow: 0 0 9px #999;
    cursor: pointer;
    z-index: 5;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>
